<template>
        <div id="register-form">
            <div id="container-register" class="container d-flex justify-content-center mt-4 align-items-center"
                style="height: 70vh">
                <div class="card w-40 rounded-3 shadow-lg">
                    <div class="card-header bg-light">
                        <h5 class="card-title text-center">Register your account</h5>
                    </div>
                    <div class="card-body">
                        <FormRegister @clickRegister="registerUser"></FormRegister>
                        <div class="mb-3 d-flex justify-content-center mt-1">
                        <div class="g-signin2" data-onsuccess="onSignIn"></div>  
                    </div>
                </div>
        </div>
</template>

<script>
import FormRegister from "../components/FormRegister";
export default {
  name: "Register",
  components: {
    FormRegister,
  },
  methods: {
    registerUser(data) {
      this.$emit("toRegister", data);
    },
  },
};
</script>

<style>
</style>